//@flow

import {
  createCrmCampaignApi,
  deleteCrmCampaignApi,
  editCrmCampaignApi,
  listCrmCampaignsApi,
  getCrmCampaignByIdApi,
  getCampaignExecutionApi,
  endpoints,
} from './api';
import {buildRoute} from '../../http';

import type {
  CrmCampaignSetting,
  CrmCampaign,
  CrmCampaignExecution,
} from '../../entities/crm/campaign';
import type {PaginationRequest, PaginationResponse} from '../../entities';

export function listCrmCampaignsService(
  params: PaginationRequest
): Promise<PaginationResponse<CrmCampaign>> {
  return listCrmCampaignsApi(params).toPromise();
}

export type CreateCampaignWebRequest = {
  name: string,
  state: 'DRAFT' | 'ACTIVE',
  onlyIncludeNews: boolean,
  ravenService: 'WHATSAPP_WEB',
  segmentId: string,
  scheduledAt: string,
  setting: {
    templateSetting: CrmCampaignSetting,
  },
};

export function createCrmCampaignService(
  request: CreateCampaignWebRequest
): Promise<CrmCampaign> {
  return createCrmCampaignApi(request).toPromise();
}

export type EditCampaignWebRequest = {
  name?: string,
  state?: 'DRAFT' | 'ACTIVE' | 'ARCHIVED',
  onlyIncludeNews?: boolean,
};

export function editCrmCampaignService(
  campaignId: string,
  request: EditCampaignWebRequest
): Promise<CrmCampaign> {
  const route = buildRoute(endpoints.EDIT_CRM_CAMPAIGN, [campaignId]);
  return editCrmCampaignApi(request, {route}).toPromise();
}

export function deleteCrmCampaignService(campaignId: string): Promise<void> {
  const route = buildRoute(endpoints.DELETE_CRM_CAMPAIGN, [campaignId]);
  return deleteCrmCampaignApi({route}).toPromise();
}

export function getCrmCampaignByIdService(
  campaignId: string
): Promise<CrmCampaign> {
  const route = buildRoute(endpoints.GET_CRM_CAMPAIGN_BY_ID, [campaignId]);
  return getCrmCampaignByIdApi(undefined, {route}).toPromise();
}

export function getCampaignExecutionService(
  campaignId: string,
  pagination: PaginationRequest = {
    page: 0,
    size: 10,
  }
): Promise<PaginationResponse<CrmCampaignExecution>> {
  const route = buildRoute(endpoints.GET_CAMPAIGN_EXECUTION, [campaignId]);
  return getCampaignExecutionApi(pagination, {route}).toPromise();
}

export function getCampaignExecutionByIdService(
  executionId: string,
  format?: 'csv' = 'csv'
): Promise<CrmCampaignExecution> {
  const route = buildRoute(endpoints.GET_CAMPAIGN_EXECUTION_BY_ID, [
    executionId,
  ]);
  return getCampaignExecutionApi({format}, {route}).toPromise();
}

export function getCampaignExecutionByIdUrl(executionId: string): string {
  const route = buildRoute(endpoints.GET_CAMPAIGN_EXECUTION_BY_ID, [
    executionId,
  ]);
  return route;
}
